import React from 'react';
import { Page, Text, View, Document, StyleSheet, PDFViewer, PDFDownloadLink } from '@react-pdf/renderer'; // https://react-pdf.org

// Create styles
const styles = StyleSheet.create({
    page: {
        flexFlow: "col nowrap",
        // backgroundColor: "#E4E4E4",
        alignItems: "flex-start",
        // margin: "10pt",
        padding: "10pt"
    },
    header: {
        display: "flex",
        flexDirection: 'row',
        justifyContent: "space-around",
        // flexFlow: 'row nowrap',
        width: "100%",
        alignItems: "flex-end",
        // margin: "1pt",
        padding: "10pt",
        flexGrow: "1",
        borderBottomStyle: "solid",
        borderBottomColor: "black",
        borderBottomWidth: "2pt",
        minHeight: "20pt",
    },
    paymentRow: {
        display: "flex",
        justifyContent: "space-around",
        // flexFlow: 'row nowrap',
        flexDirection: 'row',
        width: "100%",
        // alignItems: "flex-start",
        // margin: "0pt",
        padding: "8pt",
        // flexGrow: "1", 
        borderBottomStyle: "solid",
        borderBottomColor: "black",
        borderBottomWidth: "2pt",
        minHeight: "15pt",
    },
    paymentRowShaded: {
        display: "flex",
        justifyContent: "space-around",
        // flexFlow: 'row nowrap',
        flexDirection: 'row',
        width: "100%",
        // alignItems: "flex-start",
        // margin: "0pt",
        padding: "8pt",
        // flexGrow: "1",
        backgroundColor: "#D3D3D3",
        borderBottomStyle: "solid",
        borderBottomColor: "black",
        borderBottomWidth: "2pt",
        minHeight: "15pt",
    },
    col: {
        // flexFlow: 'row nowrap',
        // justifyContent: "center",
        flex: "1",
        // marginBottom: "12pt",
        // margin: "0.3pt",
        padding: "0.3pt",
        // borderStyle: "solid",
        // borderColor: "black",
        // borderWidth: "2pt",
        fontSize: "14pt"
    }
});

const columns = [
    { id: 'month', label: 'Month', minwidth: 50 },
    { id: 'debtName', label: 'Debt', minWidth: 100 },
    {
        id: 'regularPayment',
        label: 'Regular\nPayment',
        minWidth: 80,
        format: value => value.toFixed(2)
    },
    {
        id: 'extraPayment',
        label: 'Extra\nPayment',
        minWidth: 80,
        align: 'right',
        format: value => value.toFixed(2),
    },
    {
        id: 'totalPayment',
        label: "Total\nPayment",
        minWidth: 80,
        align: 'right',
        format: value => value.toFixed(2)
    },
    {
        id: 'interest',
        label: 'Interest',
        minWidth: 50,
        align: 'right',
        format: value => value.toFixed(2),
    },
    {
        id: 'balance',
        label: 'Balance',
        minWidth: 80,
        align: 'right',
        format: value => value.toFixed(2),
    },
];

const shading = (month) => {

    let rtnValue = styles.paymentRow
    if (month % 2 == 0) {
        rtnValue = styles.paymentRowShaded
    }

    return rtnValue
}

export default function PayoffSchedulePDF(props) {

    return (
        <Page size="LETTER" style={styles.page}>
            <View debug={false} style={styles.header}>

                {
                    columns.map(column => {

                        return (
                            <Text key={column.id} style={styles.col}>
                                {column.label}
                            </Text>
                        )

                    })
                }
            </View>
            {
                props.schedule.map((row, index) => {
                    return (
                        <View debug={false} style={shading(row.month)} wrap={false}>
                            {
                                columns.map(column => {
                                    const value = row[column.id];
                                    return (
                                        <Text style={styles.col}>
                                            {column.format && typeof value === 'number' ? column.format(value) : value}
                                        </Text>
                                    );
                                })
                            }
                        </View>
                    );
                })
            }

        </Page>

    );
}
